import React, { useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import { useTranslation } from "react-i18next";
import { alpha } from "@mui/material";
import theme from "@styles/theme";
import { Box, IconButton, Tooltip, Typography } from "@mzc-pdc/ui";
import { IconArchive, IconErrorCircle } from "@mzc-cloudplex/icons";
import { ARCHIVED_ASSET_STATUS } from "@constants";

export const AssetStatusArchived = ({ thumbnailSize = "normal", containerType, variant, status }) => {
    const { t } = useTranslation();

    const archiveIconPosition = useMemo(() => {
        if (variant === "table") {
            return {
                left: thumbnailSize === "small" ? theme.spacing(-0.75) : theme.spacing(-0.25), //Note: 해당 아이콘을 사용하는 썸네일이 작은 경우 위치가 왼쪽으로 조금 더 치우침(예시: 커스텀 컨텐츠 상세 내 에셋 목록)
                bottom: thumbnailSize === "small" ? theme.spacing(-0.5) : theme.spacing(-0.25),
            };
        } else {
            return {
                left: theme.spacing(1),
                bottom: theme.spacing(1),
            };
        }
    }, []);

    return (
        <Box
            className={clsx(`${containerType}-status`, `${containerType}-status-archived`, "additional-icons")}
            sx={{
                zIndex: 1,
                width: `auto`,
                height: `auto`,
                backgroundColor:
                    status === ARCHIVED_ASSET_STATUS.ARCHIVE_ERROR
                        ? alpha(theme.palette.greySecondary[50], 0.8)
                        : `transparent`,
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    ...archiveIconPosition,
                    width: variant === "table" ? 16 : 20,
                    height: variant === "table" ? 16 : 20,
                    display: `flex`,
                    alignItems: `center`,
                    justifyContent: `center`,
                    borderRadius: 3.75,
                    color: theme.palette.etc.gray500,
                    backgroundColor: alpha(theme.palette.constant.white, 0.92),
                }}
            >
                <IconArchive size={variant === "table" ? 12 : 16} />
            </Box>

            {status === ARCHIVED_ASSET_STATUS.ARCHIVE_ERROR && (
                <Box
                    sx={{
                        position: "absolute",
                        left: variant === "table" ? theme.spacing(2) : theme.spacing(4),
                        bottom: variant === "table" ? theme.spacing(0) : theme.spacing(1.25),
                        height: "18px",
                    }}
                >
                    <Tooltip
                        title={
                            <Typography variant={"body4_400"}>
                                {t(`common::msg::An attempt to 'Archive' failed. Please try again.`)}
                            </Typography>
                        }
                    >
                        <IconButton size={"xxsmall"} circled onClick={() => {}} sx={{ p: 0 }}>
                            <IconErrorCircle size={variant === "table" ? 12 : 16} color={"error"} />
                        </IconButton>
                    </Tooltip>
                </Box>
            )}
        </Box>
    );
};
AssetStatusArchived.propTypes = {
    containerType: PropTypes.oneOf(["card", "list"]).isRequired,
};
AssetStatusArchived.defaultProps = {
    containerType: "card",
};

export default React.memo(AssetStatusArchived);
